import { Alert, Box, Card, Grid2 as Grid, Link, Stack, Typography, useTheme } from '@mui/material';


interface Props {
   nextReportId: number;
   isIE?: boolean;
}

const ReportAmendedReasonBlock = (props: Props): JSX.Element => {

    const theme = useTheme();
    
    return (
        <Grid size={12}>
            <Box width={"100%"}>
                <Stack direction="row" spacing={1} component={Link} href={`/reports/displayreport?id=${props.nextReportId}${props.isIE ? '&isIE=1' : ''}`} underline="none" marginBottom={2}>
                    <Alert variant='outlined' severity="warning" sx={{ width: '100%'}} >This report has been amended, click to see the amendment.</Alert>
                </Stack>
            </Box>
        </Grid>
    );
}

export default ReportAmendedReasonBlock;